import styles from './QuantityStepper.module.css';

/** Quantity never drops below `min` — decrementing at the floor is a no-op, matching the prototype. */
export function QuantityStepper({ value, onIncrement, onDecrement, size = 'md', label = 'Quantity', min = 1 }) {
  return (
    <div className={`${styles.stepper} ${styles[size]}`}>
      <button
        type="button"
        className={styles.btn}
        onClick={onDecrement}
        disabled={value <= min}
        aria-label={`Decrease ${label.toLowerCase()}`}
      >
        −
      </button>
      <span className={styles.value} aria-live="polite">
        {value}
      </span>
      <button
        type="button"
        className={styles.btn}
        onClick={onIncrement}
        aria-label={`Increase ${label.toLowerCase()}`}
      >
        +
      </button>
    </div>
  );
}
